import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

export default function FooterApp() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#273846",
        padding: "40px 20px",
        position: "relative",
        marginTop: "auto",
      }}
    >
      <Grid container spacing={1} justifyContent="center" alignItems="center">
        {/* <Link
          href={process.env.REACT_APP_XEOPROD_APP_TERMS}
          target="_blank"
          underline="hover"
          sx={{ color: "white", textUnderlineOffset: "8px" }}
        >
          <Typography>Politique de confidentialité</Typography>
        </Link> */}
        <Typography color="white">© Copyright Le Cabinet Comptable 2025</Typography>
      </Grid>
    </Box>
  );
}
